// client/src/views/Sidebar_parts/SidebarHeaderAndLabels.js
import React from "react";
import LoginButton from "../../components/LoginButton";

export function SidebarHeader({
  logo,
  styles = {},
  mapDisplayName,
  gameName,
  creatorSignature,
  showLoginPrompt,
  onVoteClick,
  safeVoteStatus,
  isFavourited,
  favLoading,
  handleFavourite,
  user,
  onUserLogin,
  hasTitleImage,
  fontColour,
  mainFont,
}) {
  const titleImageUrl = styles.title_image_url;
  const titleText = styles.title_text || mapDisplayName;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginBottom: hasTitleImage ? 0 : 5,
        paddingTop: hasTitleImage ? 0 : 12,
        background: "transparent",
        width: "100%",
        paddingLeft: hasTitleImage ? 0 : 5,
        paddingRight: hasTitleImage ? 0 : 12,
        boxSizing: "border-box",
        userSelect: "none",
      }}
    >
      <a href="/" title="Go to Home" style={{ marginBottom: hasTitleImage ? -100 : -50 }}>
        <img
          src={logo}
          alt="Point Atlas Logo"
          style={{
            maxWidth: 50,
            maxHeight: 50,
            width: "auto",
            height: "auto",
            display: "block",
            cursor: "pointer",
            marginBottom: 50,
            marginTop: 20,
          }}
        />
      </a>

      {hasTitleImage && titleImageUrl && (
        <img
          src={titleImageUrl}
          alt="Game Logo"
          style={{
            width: "80%",
            maxHeight: 150,
            objectFit: "fill",
            display: "block",
            marginTop: 0,
            marginBottom: 0,
            userSelect: "none",
            pointerEvents: "none",
          }}
        />
      )}

      {!hasTitleImage && (
        <span
          style={{
            fontWeight: "bold",
            fontSize: "1.90em",
            margin: "4px 0 0 0",
            letterSpacing: "1px",
            color: fontColour,
            textAlign: "center",
            width: "100%",
            fontFamily: mainFont,
            userSelect: "none",
          }}
        >
          {titleText}
        </span>
      )}

      {gameName && !hasTitleImage && (
        <div
          style={{
            fontSize: "1.1em",
            fontWeight: "600",
            color: "#ffc73c",
            marginTop: 2,
            marginBottom: 6,
            textTransform: "capitalize",
            textAlign: "center",
            width: "100%",
            userSelect: "none",
          }}
        >
          {gameName}
        </div>
      )}

      {creatorSignature && (
        <div
          style={{
            color: "#ccc",
            fontSize: 13,
            fontWeight: "bold",
            margin: "4px 0 0 0",
            fontStyle: "italic",
            textAlign: "center",
            width: "90%",
            letterSpacing: "0.5px",
            opacity: 0.82,
            userSelect: "none",
          }}
        >
          {creatorSignature}
        </div>
      )}

      {showLoginPrompt && (
        <div
          style={{
            background: "#201c09",
            color: "#ffe17e",
            fontWeight: 700,
            border: "1.5px solid #ffe17e",
            borderRadius: 8,
            padding: "10px 10px 10px 10px",
            margin: "12px 0 0 0",
            width: "94%",
            textAlign: "center",
            zIndex: 11,
            userSelect: "none",
          }}
        >
          Sorry, you need to be logged in to vote.
          <br />
          <LoginButton onLogin={onUserLogin} />
        </div>
      )}

      <div
        style={{
          marginTop: hasTitleImage ? "-50px" : 7,
          display: "flex",
          alignItems: "center",
          gap: 8,
          userSelect: "none",
        }}
      >
        <div
          onClick={() => onVoteClick(1)}
          title={user ? "Upvote this map" : "Log in to vote"}
          style={{
            cursor: user ? "pointer" : "not-allowed",
            backgroundColor: safeVoteStatus.user_vote === 1 ? "#4cc153" : "#222",
            borderRadius: 8,
            width: 36,
            height: 36,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: safeVoteStatus.user_vote === 1 ? "#fff" : "#4cc153",
            fontWeight: "bold",
            fontSize: 22,
            userSelect: "none",
          }}
        >
          👍
        </div>

        <div
          style={{
            fontWeight: "bold",
            fontSize: 18,
            color: "#4cc153",
            minWidth: 26,
            textAlign: "center",
            userSelect: "none",
            pointerEvents: "none",
          }}
        >
          {safeVoteStatus.total_votes}
        </div>

        <div
          onClick={() => onVoteClick(-1)}
          title={user ? "Downvote this map" : "Log in to vote"}
          style={{
            cursor: user ? "pointer" : "not-allowed",
            backgroundColor: safeVoteStatus.user_vote === -1 ? "#ff5959" : "#222",
            borderRadius: 8,
            width: 36,
            height: 36,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: safeVoteStatus.user_vote === -1 ? "#fff" : "#ff5959",
            fontWeight: "bold",
            fontSize: 22,
            userSelect: "none",
          }}
        >
          👎
        </div>

        <button
          style={{
            background: isFavourited ? "#ffc73c" : "#2d2e31",
            color: isFavourited ? "#222" : "#fff",
            border: "none",
            borderRadius: 8,
            padding: "7px 16px",
            fontWeight: 700,
            fontSize: 16,
            cursor: favLoading ? "wait" : user ? "pointer" : "not-allowed",
            display: "flex",
            alignItems: "center",
            gap: 6,
            boxShadow: isFavourited ? "0 2px 14px #ffd70044" : "none",
            opacity: favLoading ? 0.7 : 1,
            transition: "background 0.16s, color 0.16s",
            userSelect: "none",
          }}
          onClick={handleFavourite}
          disabled={favLoading || !user}
          title={
            !user
              ? "Log in to favourite maps"
              : isFavourited
              ? "Remove from favourites"
              : "Add to Favourites"
          }
        >
          <span
            style={{
              fontSize: 21,
              color: isFavourited ? "#e6ad00" : "#bbb",
              marginRight: 6,
            }}
          >
            {isFavourited ? "★" : "☆"}
          </span>
          {isFavourited ? "Favourited" : "Add to Favourites"}
        </button>
      </div>
    </div>
  );
}

export function PoiLabelControls({
  poiLabelToggleBtn,
  hasTitleImage,
  labelScale,
  setLabelScale,
  minLabelScale,
  maxLabelScale,
}) {
  if (!poiLabelToggleBtn) return null;

  let labelsVisible = false;

  if (poiLabelToggleBtn && poiLabelToggleBtn.props) {
    const children = poiLabelToggleBtn.props.children;
    let text = "";
    if (typeof children === "string") {
      text = children;
    } else if (Array.isArray(children)) {
      text = children.join(" ");
    }
    if (typeof text === "string" && text.toLowerCase().includes("hide all poi labels")) {
      labelsVisible = true;
    }
  }

  const isMobile =
    typeof window !== "undefined" && Number.isFinite(window.innerWidth) ? window.innerWidth <= 820 : false;

  const mobileInline = Boolean(isMobile && labelsVisible);

  return (
    <div
      style={{
        textAlign: "center",
        margin: hasTitleImage ? "0 0 4px 0" : "12px 0 4px 0",
      }}
    >
      {mobileInline ? (
        <div
          style={{
            marginTop: 0,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 10,
            paddingLeft: 10,
            paddingRight: 10,
            boxSizing: "border-box",
            width: "100%",
          }}
        >
          <div style={{ flex: "0 0 auto" }}>{poiLabelToggleBtn}</div>

          <div
            style={{
              flex: "1 1 auto",
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: 4,
              maxWidth: 340,
            }}
          >
            <span
              style={{
                fontSize: 12,
                opacity: 0.85,
                userSelect: "none",
                whiteSpace: "nowrap",
                lineHeight: 1.1,
              }}
            >
              POI label size
            </span>

            <input
              type="range"
              min={minLabelScale}
              max={maxLabelScale}
              step={0.05}
              value={labelScale}
              onChange={(e) => {
                const v = parseFloat(e.target.value);
                if (!Number.isNaN(v)) {
                  let clamped = v;
                  if (clamped < minLabelScale) clamped = minLabelScale;
                  if (clamped > maxLabelScale) clamped = maxLabelScale;
                  setLabelScale(clamped);
                }
              }}
              style={{
                width: "100%",
                cursor: "pointer",
                minWidth: 150,
              }}
            />
          </div>
        </div>
      ) : (
        <>
          {poiLabelToggleBtn}
          {labelsVisible && (
            <div
              style={{
                marginTop: 6,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 4,
              }}
            >
              <span
                style={{
                  fontSize: 12,
                  opacity: 0.85,
                  userSelect: "none",
                }}
              >
                POI label size
              </span>
              <input
                type="range"
                min={minLabelScale}
                max={maxLabelScale}
                step={0.05}
                value={labelScale}
                onChange={(e) => {
                  const v = parseFloat(e.target.value);
                  if (!Number.isNaN(v)) {
                    let clamped = v;
                    if (clamped < minLabelScale) clamped = minLabelScale;
                    if (clamped > maxLabelScale) clamped = maxLabelScale;
                    setLabelScale(clamped);
                  }
                }}
                style={{
                  width: "70%",
                  cursor: "pointer",
                }}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default SidebarHeader;
